import { render, staticRenderFns } from "./CommunityHappinessAnnualRanking.vue?vue&type=template&id=4f2a03c8&scoped=true&"
import script from "./CommunityHappinessAnnualRanking.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessAnnualRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2a03c8",
  null
  
)

export default component.exports